import ICategoryTemplate from '@/models/interfaces/ICategoryTemplate';

export default class CategoryTemplate implements ICategoryTemplate {
  name: string;

  description: string;

  novice = false;

  isPointsExcluded = false;

  constructor(name: string, description: string, novice: boolean, isPointsExcluded: boolean) {
    this.name = name;
    this.description = description;
    this.novice = novice;
    this.isPointsExcluded = isPointsExcluded;
  }
}
